// extracted by mini-css-extract-plugin
export default {"root":"order-book-ico_root__3s9AF"};